module.exports = __webpack_public_path__ + "img/worldmap_dada_yellow.4a0a2913.png";